import axios from "axios";
import qs from "qs";
import { Key } from "react";
import { download } from "utils/common";
import { EndExerciseOptionModel } from "./exercise";
import { searchItem } from "../pages/answerStore/MyStore";

export enum AnswerStoreNavType {
    main, //主体
    result //结果
}

export enum CurrentTermType {
    noCurrent = 0,
    isCurrent = 1
}

export enum QuestionType { //0：练习 1：作业 2：考试
    exercise = "0",
    homework = "1",
    exam = "2"
}

export const QuestionTypeMap = {
    [QuestionType.exercise]: "练习",
    [QuestionType.homework]: "作业",
    [QuestionType.exam]: "考试"
};

interface CourseListItem {
    id: string;
    batchNo: string; //学期编码
    courseNo: string; // 课程编码
    courseName: string; //课程名称
    courseSeq: string; //课序号
}

/**
 * 获取老师的课程
 * @param batchNo
 * @returns
 */

export function getCourseListByTeacher(batchNo?: string[]) {
    const params = !!batchNo?.length ? batchNo?.join(",") : undefined;
    return axios
        .post<SuccessData<CourseListItem[]>>(
            `/teacher/exercise/getCourseListByTeacher`,
            qs.stringify({ batchNo: params })
        )
        .then(res => res.data.data);
}

interface QuestionParams {
    batchNo?: string[]; //学期编码 多个逗号分隔
    courseNo?: string[]; //课程编码 多个逗号分隔
    search?: string; //题干关键字
    queTypeId?: QueTypeId[]; //题型
    paperType?: QuestionType[]; //类别
    pageNo: number; //页码
    pageSize: number; //条数
}

export interface QuestionListItem {
    questionId: string; //题id
    batchName: string; //学期名称
    courseName: string; //课程名称
    courseNo: string; //课程编码
    courseSeq: string; //课序号
    queTypeDescription: string; //题型
    questionDescription: string; //题干，注意<P>
    paperType: QuestionType; //类别 0：练习 1：作业 2：考试
    createTime: string; //创建时间
    options: EndExerciseOptionModel[];
    scope?: number; //分值，构造用
    queTypeId: QueTypeId;
}

export enum QueTypeId {
    Radio = "1",
    Checkbox = "2",
    Judgment = "3",
    Fill = "5"
}
export interface QuestionList {
    list: QuestionListItem[];
    count: number; //总数
}

/**
 * 获取我的题库数据
 * @param params
 * @returns
 */

export function getMyQuestionList(params: QuestionParams) {
    const data = {
        ...params,
        batchNo: params?.batchNo?.join(","),
        queTypeId: params?.queTypeId?.join(","),
        paperType: params?.paperType?.join(","),
        courseNo: params?.courseNo?.join(","),
        search: params?.search?.trim()
    };
    return axios
        .post<SuccessData<QuestionList>>(
            `/teacher/exercise/getMyQuestionList`,
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

/**
 * 批量导入我的题库习题
 */
export function importQuestionExcel(file: File, batchNo: string) {
    const headers = { "Content-Type": "multipart/Form-data" };
    const formData = new FormData();
    formData.append("file", file);
    formData.append("batchNo", batchNo);
    return axios.post(`/teacher/exercise/importQuestionExcel`, formData, {
        headers
    });
}

/**
 * 题库导入的EXCEL模板
 */
export function downloadQuestionTemplate() {
    return download("GET", "/teacher/exercise/downloadQuestionTemplate").then(
        res => {
            let fileName = window.decodeURI(
                res.headers["content-disposition"].split("=")[1]
            );

            let url = window.URL.createObjectURL(res.data);
            let link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    );
}

/**
 * 下载导入失败的EXCEL文件
 * @param fileName
 * @returns
 */
export function downloadQuestionErrExcel(fileName: string) {
    return download(
        "GET",
        `/teacher/exercise/downloadQuestionErrExcel?fileName=${fileName}`
    ).then(res => {
        let url = window.URL.createObjectURL(res.data); //表示一个指定的file对象或Blob对象
        let link = document.createElement("a");
        link.href = url;
        link.download = fileName; //命名下载名称
        link.click(); //点击触发下载
        window.URL.revokeObjectURL(url); //下载完成进行释放
    });
}

export enum ImportState {
    success = "1",
    error = "2"
}

export interface ImportResultListItem {
    createTime: string;
    fileName: string;
    state: ImportState;
}

/**
 * 考核导入情况查询
 */
export function findImportLog() {
    return axios
        .post<SuccessData<ImportResultListItem[]>>(
            `/teacher/exercise/findImportLog`
        )
        .then(res => res.data.data);
}

export interface QuestionTypeCountList {
    score: number;
    typeCount: number; //题数
    typeId: string; //题型id
    typeName: string; //题型名称
    icon?: string;
    counts: number;
}

//多处引用，慎改
export interface SearchParams {
    batchNo?: string[]; //学期
    courseNo?: string[]; //课程编号
    paperType?: string[]; //类型
}

/**
 * 获取我的题库题型数量
 * @param params
 * @returns
 */

export function getMyQuestionTypeCount(params: SearchParams) {
    const data = {
        ...params,
        batchNo: params.batchNo?.length ? params.batchNo.join(",") : undefined,
        courseNo: params.courseNo?.length
            ? params.courseNo.join(",")
            : undefined,
        paperType: params.paperType?.length
            ? params.paperType.join(",")
            : undefined
    };
    return axios
        .post<SuccessData<QuestionTypeCountList[]>>(
            `/teacher/exercise/getMyQuestionTypeCount`,
            qs.stringify(data)
        )
        .then(res => res.data.data)
        .then(data => data.map(item => ({ ...item, score: 5 })));
}

/**
 * 根据试卷策略保存考试试卷
 * @param params
 * @returns
 */

interface saveParams extends SearchParams {
    examId: string;
    data: {
        typeId: string;
        typeCount: number;
        score: number;
    }[];
}

export function saveExamPaperByStrategy(params: saveParams) {
    const data = params.data.filter(item => item.typeCount !== 0);
    const newParams = {
        ...params,
        batchNo: params.batchNo?.length ? params.batchNo.join(",") : undefined,
        courseNo: params.courseNo?.length
            ? params.courseNo.join(",")
            : undefined,
        paperType: params.paperType?.length
            ? params.paperType.join(",")
            : undefined,
        data: data
    };

    return axios({
        url: `/teacher/exercise/saveExamPaperByStrategy`,
        method: "post",
        data: newParams,
        headers: { "Content-Type": "application/json" }
    });
}

/**
 * 删除/批量删除计划
 */

export function deleteMyQuestions(questionIds: Key[]) {
    const newParams = questionIds.join(",");
    return axios.post(
        `/teacher/exercise/deleteMyQuestions`,
        qs.stringify({ questionIds: newParams })
    );
}

/**
 * 导出题库
 * @param params
 */
export function exportQuestion(params: searchItem) {
    const data = {
        ...params,
        batchNo: params?.batchNo?.join(","),
        queTypeId: params?.queTypeId?.join(","),
        paperType: params?.paperType?.join(","),
        courseNo: params?.courseNo?.join(","),
        search: params?.search?.trim()
    };

    return download(
        "POST",
        `/teacher/exercise/exportQuestion?${qs.stringify(data)}`
    ).then(res => {
        let url = window.URL.createObjectURL(res.data); //表示一个指定的file对象或Blob对象
        let link = document.createElement("a");
        link.href = url;
        link.download = "question.xlsx"; //命名下载名称
        link.click(); //点击触发下载
        window.URL.revokeObjectURL(url); //下载完成进行释放
    });
}
